import { render, staticRenderFns } from "./CustomerProjectionTable.vue?vue&type=template&id=00e5d6f8&scoped=true&"
import script from "./CustomerProjectionTable.vue?vue&type=script&lang=js&"
export * from "./CustomerProjectionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e5d6f8",
  null
  
)

export default component.exports